import { render } from "./BaseDropdownBtn.vue?vue&type=template&id=65461790&scoped=true"
import script from "./BaseDropdownBtn.vue?vue&type=script&lang=js"
export * from "./BaseDropdownBtn.vue?vue&type=script&lang=js"

import "./BaseDropdownBtn.vue?vue&type=style&index=0&id=65461790&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65461790"]])

export default __exports__